import { useState } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { graphql } from 'react-apollo';
import compose from 'lodash/flowRight';
// Queries
import CURRENT_USER from '../../GraphQl/Queries/CURRENT_USER';
import LIST_ORGS_TREE from '../../GraphQl/Queries/LIST_ORGS_TREE';
// Mutations
import CREATE_ORG_ADMIN from '../.././GraphQl/Mutations/CREATE_ORG_ADMIN';
import EDIT_ORG_ADMIN from '../.././GraphQl/Mutations/EDIT_ORG_ADMIN';
import EDIT_ORG_SELF from '../.././GraphQl/Mutations/EDIT_ORG_SELF';
import DELETE_ORG_ADMIN from '../.././GraphQl/Mutations/DELETE_ORG_ADMIN';
import FULL_DELETE_ORG_ADMIN from '../.././GraphQl/Mutations/FULL_DELETE_ORG_ADMIN';
import DISABLE_ORG from '../../../core/GraphQl/Mutations/DISABLE_ORG';
import ENABLE_ORG from '../../../core/GraphQl/Mutations/ENABLE_ORG';
import MOVE_ORG from '../../../core/GraphQl/Mutations/MOVE_ORG';
import CREATE_DSP_ADVERTISER from '../../../core/GraphQl/Mutations/CREATE_DSP_ADVERTISER';
import CREATE_SALESFORCE_FOR_ORG from '../../../core/GraphQl/Mutations/CREATE_SALESFORCE_FOR_ORG';

// Local Mutations
import UPDATE_USER from '../../../core/GraphQl/Mutations/UPDATE_USER';

// Locals
import Controller from './Controller';
import OverlaySpinner from '../../.././platform/shared/OverlaySpinner';

import { getRolesFeatures } from '../../utils/dataManipulating/organization';

// Constant
import { errorType } from '../../utils/constants/constants';

import { isEmpty, isBoolean, get } from 'lodash';
import UPDATE_ORG_SEND_EMAIL_CONFIG from '../../GraphQl/Mutations/UPDATE_ORG_SEND_EMAIL_CONFIG';

const Loader = (props) => {
  const { currentUser } = props;

  const loggedInRole = currentUser.role;
  const [pageSize] = useState(300);
  const [pageNumber, setPageNumber] = useState(1);
  const config = currentUser.role.org.config;
  const [newOrgs, setNewOrgs] = useState([]);

  const createOrg = async (data) => {
    const {
      name,
      description,
      level,
      chatWootId,
      cpm,
      rpm,
      website,
      domain,
      logo,
      parentOrgId,
      roleitems,
      parentOrg,
      config,
      dataConfig,
      signInLogo,
      platformDomain,
      tagDomain,
      CPAcronym,
      zone,
      modelType,
      contract,
      displayCPM,
      displayContractCPM,
      videoCPM,
      videoContractCPM,
      premiumDisplayCPM,
      premiumDisplayContractCPM,
      tvOttStandardCPM,
      tvOttStandardContractCPM,
      tvOttPremiumCPM,
      tvOttPremiumContractCPM,
      percentage,
      contractPercentage,
      salesforceId,
    } = data;

    if (!dataConfig.reTargeting) {
      dataConfig.appIds = [];
    }

    try {
      const response = await props.createOrgMutation({
        variables: {
          name,
          description,
          level,
          chatWootId,
          cpm: cpm.toLocaleString(),
          rpm: rpm,
          website,
          domain: isEmpty(domain) ? null : domain,
          platformDomain: isEmpty(platformDomain) ? null : platformDomain,
          tagDomain: isEmpty(tagDomain) ? null : tagDomain,
          logoId: isEmpty(logo) ? null : { connect: { id: logo } },
          CPAcronym: isEmpty(CPAcronym) ? null : CPAcronym,
          signInLogoId: isEmpty(signInLogo) ? null : { connect: { id: signInLogo.id } },
          parentOrgId,
          roleitems,
          parentOrgs: parentOrg.map((org) => {
            return { id: org.id };
          }),
          config,
          reTargeting: dataConfig.reTargeting,
          appIds: dataConfig.appIds,
          tradeDeskIdentifier: dataConfig.tradeDeskIdentifier,
          storageBucket: dataConfig.storageBucket,
          googleCustomerId: dataConfig.googleCustomerId,
          seo: dataConfig.seo,
          semrushEnable: dataConfig.semrushEnable,
          projectId: dataConfig.semrushConfig.projectId,
          rootDomainUrl: dataConfig.semrushConfig.rootDomainUrl,
          rootKeyword: dataConfig.semrushConfig.rootKeyword,
          competitor1stRootDomainUrl: dataConfig.semrushConfig.competitor1stRootDomainUrl,
          competitor2ndRootDomainUrl: dataConfig.semrushConfig.competitor2ndRootDomainUrl,
          viewId: dataConfig.googleAnalytics.viewId,
          isGA4: dataConfig.googleAnalytics.isGA4,
          zone: isEmpty(zone) ? null : zone,
          modelType,
          contract,
          displayCPM,
          displayContractCPM,
          videoCPM,
          videoContractCPM,
          premiumDisplayCPM,
          premiumDisplayContractCPM,
          tvOttStandardCPM,
          tvOttStandardContractCPM,
          tvOttPremiumCPM,
          tvOttPremiumContractCPM,
          percentage,
          contractPercentage,
          salesforceId: salesforceId || null,
        },
        update: (store, { data: { createOrg } }) => {
          let newOrgsSlice = newOrgs.slice();
          newOrgsSlice.splice(0, 0, createOrg);
          setNewOrgs(newOrgsSlice);
        },
      });
      if (response) {
        return {
          status: 'success',
          error: null,
          data: response.data.createOrg,
        };
      }
      return response;
    } catch (err) {
      const { nameDuplicate, domainDuplicate } = errorType;
      if (err.message === nameDuplicate) {
        return {
          status: 'failure',
          error: nameDuplicate,
        };
      } else if (err.message === domainDuplicate) {
        return {
          status: 'failure',
          error: domainDuplicate,
        };
      } else {
        return {
          status: 'failure',
          error: err,
        };
      }
    }
  };

  const disableOrg = async (record) => {
    try {
      const response = await props.disableOrg({
        variables: { id: record.id },
        update: (store, { data: { disableOrg } }) => {
          let newOrgsSlice = newOrgs.slice();
          const indexToUpdate = newOrgs.findIndex((org) => org.id === disableOrg.id);
          newOrgsSlice.splice(indexToUpdate, 1, disableOrg);
          setNewOrgs(newOrgsSlice);
        },
      });
      if (response) {
        return {
          data: response.data.disableOrg,
          status: 'success',
          error: null,
        };
      }
    } catch (err) {
      return {
        status: 'failure',
        error: err,
      };
    }
  };

  const enableOrg = async (record) => {
    try {
      const response = await props.enableOrg({
        variables: { id: record.id },
        update: (store, { data: { enableOrg } }) => {
          let newOrgsSlice = newOrgs.slice();
          const indexToUpdate = newOrgsSlice.findIndex((org) => org.id === enableOrg.id);
          newOrgsSlice.splice(indexToUpdate, 1, enableOrg);
          setNewOrgs(newOrgsSlice);
        },
      });
      if (response) {
        return {
          data: response.data.enableOrg,
          status: 'success',
          error: null,
        };
      }
    } catch (err) {
      return {
        status: 'failure',
        error: err,
      };
    }
  };

  const deleteOrg = async (record) => {
    try {
      const response = await props.deleteOrgMutation({
        variables: {
          Id: record.id,
        },
        update: (store, { data: { deleteOrg } }) => {
          let newOrgsSlice = newOrgs.slice();
          newOrgsSlice = newOrgsSlice
            .map((org) => {
              return {
                ...org,
                parentOrg: org.parentOrg.filter((org) => org.id !== deleteOrg.id),
              };
            })
            .filter((org) => org.id !== deleteOrg.id);
          setNewOrgs(newOrgsSlice);
        },
      });

      if (response) {
        return {
          status: 'success',
          error: null,
        };
      }
    } catch (err) {
      return {
        status: 'failure',
        error: err,
      };
    }
  };

  const fullDeleteOrg = async (record) => {
    try {
      const response = await props.fullDeleteOrgMutation({
        variables: {
          Id: record.id,
          confirmFullDelete: true,
        },
        update: (store, { data: { fullDeleteOrg } }) => {
          let newOrgsSlice = newOrgs.slice();
          newOrgsSlice = newOrgsSlice
            .map((org) => {
              return {
                ...org,
                parentOrg: org.parentOrg.filter((org) => org.id !== fullDeleteOrg.id),
              };
            })
            .filter((org) => org.id !== fullDeleteOrg.id);
          setNewOrgs(newOrgsSlice);
        },
      });

      if (response) {
        return {
          status: 'success',
          error: null,
        };
      }
    } catch (err) {
      return {
        status: 'failure',
        error: err,
      };
    }
  };

  const moveOrg = async (variables) => {
    try {
      // Extract the parameters to match the GraphQL Playground structure
      const { id, connect, disconnect } = variables.variables;
      const response = await props.moveOrgMutation({
        variables: {
          id,
          connect,
          disconnect,
        },
        refetchQueries: [
          {
            query: LIST_ORGS_TREE,
            variables: {
              parentid: loggedInRole.org.id,
              first: pageSize,
              skip: 0,
            },
          },
        ],
        awaitRefetchQueries: true,
      });

      if (response && response.data && response.data.moveOrg) {
        // Reset page number to 1 to trigger complete recursive loading after move
        setPageNumber(1);
        // Clear the current newOrgs to force a complete reload
        setNewOrgs([]);
        // Force a complete refetch to ensure consistent state
        await refetchOrganizations({
          first: pageSize,
          skip: 0,
        });
        return {
          status: 'success',
          error: null,
          data: response.data.moveOrg,
        };
      }

      return {
        status: 'failure',
        error: 'No data returned from moveOrg mutation',
      };
    } catch (err) {
      return {
        status: 'failure',
        error: err.message || err,
      };
    }
  };

  const editOrg = async (data) => {
    const {
      id,
      name,
      description,
      level,
      chatWootId,
      cpm,
      rpm,
      website,
      domain,
      logo,
      parentOrgId,
      roleitems,
      roles,
      defaultOrg,
      config,
      dataConfig,
      signInLogo,
      platformDomain,
      tagDomain,
      CPAcronym,
      zone,
      pricingModel,
      modelType,
      contract,
      displayCPM,
      displayContractCPM,
      videoCPM,
      videoContractCPM,
      premiumDisplayCPM,
      premiumDisplayContractCPM,
      tvOttStandardCPM,
      tvOttStandardContractCPM,
      tvOttPremiumCPM,
      tvOttPremiumContractCPM,
      percentage,
      contractPercentage,
      salesforceId,
      billingEmail,
    } = data;
    const cpmList = pricingModel.cpmList || [];
    const displayCPMData = cpmList.find((cpm) => cpm.type === 'DISPLAY');
    const videoCPMData = cpmList.find((cpm) => cpm.type === 'VIDEO');
    const premiumDisplayCPMData = cpmList.find((cpm) => cpm.type === 'PREMIUM_DISPLAY');
    const tvOttStandardCPMData = cpmList.find((cpm) => cpm.type === 'TV_OTT_STANDARD');
    const tvOttPremiumCPMData = cpmList.find((cpm) => cpm.type === 'TV_OTT_PREMIUM');

    if (name === defaultOrg) {
      try {
        const response = await props.updateOrgBasic({
          variables: {
            id,
            name,
            description,
            level,
            chatWootId,
            cpm: cpm.toLocaleString(),
            rpm: rpm,
            website,
            domain: isEmpty(domain) ? null : domain,
            logoId: isEmpty(logo) ? null : { id: logo.id },
            signInLogoId: isEmpty(signInLogo) ? null : { id: signInLogo.id },
            platformDomain: isEmpty(platformDomain) ? null : platformDomain,
            tagDomain: isEmpty(tagDomain) ? null : tagDomain,
            CPAcronym: isEmpty(CPAcronym) ? null : CPAcronym,
            zone: isEmpty(zone) ? null : zone,
            salesforceId: salesforceId || null,
            billingEmail: billingEmail || null,
          },
          refetchQueries: [
            {
              query: LIST_ORGS_TREE,
              variables: {
                parentid: loggedInRole.org.id,
                first: pageSize,
                skip: (Number(pageNumber) - 1) * pageSize,
              },
            },
          ],
        });

        if (response) {
          return {
            status: 'success',
            error: null,
            data: response.data.updateOrg,
          };
        }
        return response;
      } catch (err) {
        return {
          status: 'failure',
          error: err,
        };
      }
    } else {
      if (config) delete config.__typename;
      if (dataConfig) delete dataConfig.__typename;
      // if config is null
      let tempConfig = !config ? { providersVisible: false } : config;

      if (!dataConfig.reTargeting) {
        dataConfig.appIds = [];
      }

      // The Org's master flag. Might be changed to look at the type field
      const roleId = roles.find((role) => role.isMaster).id;

      try {
        const response = await props.updateOrgMutation({
          variables: {
            id,
            name,
            description,
            level,
            chatWootId,
            cpm: cpm.toLocaleString(),
            rpm: rpm,
            website,
            domain: isEmpty(domain) ? null : domain,
            logoId: isEmpty(logo) ? null : { id: logo.id },
            signInLogoId: isEmpty(signInLogo) ? null : { id: signInLogo.id },
            platformDomain: isEmpty(platformDomain) ? null : platformDomain,
            tagDomain: isEmpty(tagDomain) ? null : tagDomain,
            CPAcronym: isEmpty(CPAcronym) ? null : CPAcronym,
            parentOrgId,
            roleitems,
            roleId,
            createConfig: tempConfig,
            updateConfig: tempConfig,
            reTargeting: dataConfig.reTargeting,
            appIds: dataConfig.appIds,
            tradeDeskIdentifier: dataConfig.tradeDeskIdentifier,
            storageBucket: dataConfig.storageBucket,
            googleCustomerId: dataConfig.googleCustomerId,
            seo: isBoolean(dataConfig.seo) ? dataConfig.seo : false,
            semrushEnable: dataConfig.semrushEnable,
            projectId: dataConfig.semrushConfig ? dataConfig.semrushConfig.projectId : null,
            rootDomainUrl: dataConfig.semrushConfig ? dataConfig.semrushConfig.rootDomainUrl : null,
            rootKeyword: dataConfig.semrushConfig ? dataConfig.semrushConfig.rootKeyword : null,
            competitor1stRootDomainUrl: dataConfig.semrushConfig
              ? dataConfig.semrushConfig.competitor1stRootDomainUrl
              : null,
            competitor2ndRootDomainUrl: dataConfig.semrushConfig
              ? dataConfig.semrushConfig.competitor2ndRootDomainUrl
              : null,
            viewId: get(dataConfig.googleAnalytics, 'viewId', null),
            isGA4: dataConfig.googleAnalytics ? dataConfig.googleAnalytics.isGA4 : false,
            bingCustomerId: dataConfig.bing ? dataConfig.bing.customerId : null,
            bingAccountId: dataConfig.bing ? dataConfig.bing.accountId : null,
            processTag: dataConfig.tagProcessingConfig
              ? dataConfig.tagProcessingConfig.processTag
              : false,
            paidSearchIsEnable: dataConfig.paidSearchDataConfig
              ? dataConfig.paidSearchDataConfig.isEnabled
              : false,
            zone: isEmpty(zone) ? null : zone,
            modelType,
            contract,
            displayCPM: displayCPM.toLocaleString(),
            displayContractCPM: displayContractCPM.toLocaleString(),
            videoCPM: videoCPM.toLocaleString(),
            videoContractCPM: videoContractCPM.toLocaleString(),
            premiumDisplayCPM: premiumDisplayCPM.toLocaleString(),
            premiumDisplayContractCPM: premiumDisplayContractCPM.toLocaleString(),
            tvOttStandardCPM: tvOttStandardCPM.toLocaleString(),
            tvOttStandardContractCPM: tvOttStandardContractCPM.toLocaleString(),
            tvOttPremiumCPM: tvOttPremiumCPM.toLocaleString(),
            tvOttPremiumContractCPM: tvOttPremiumContractCPM.toLocaleString(),
            percentage: percentage.toLocaleString(),
            contractPercentage: contractPercentage.toLocaleString(),
            displayID: displayCPMData?.id || null,
            videoID: videoCPMData?.id || null,
            premiumDisplayID: premiumDisplayCPMData?.id || null,
            tvOttStandardID: tvOttStandardCPMData?.id || null,
            tvOttPremiumID: tvOttPremiumCPMData?.id || null,
            salesforceId: salesforceId || null,
            billingEmail: billingEmail || null,
          },
          refetchQueries: [
            {
              query: LIST_ORGS_TREE,
              variables: {
                parentid: loggedInRole.org.id,
                skip: (Number(pageNumber) - 1) * pageSize,
              },
            },
          ],
        });
        if (response) {
          return {
            status: 'success',
            error: null,
            data: response.data.updateParentOrg,
          };
        }
        return response;
      } catch (err) {
        console.log(err);
        return {
          status: 'failure',
          error: err,
        };
      }
    }
  };

  // Assume Role
  const assumeRole = async (previewRole) => {
    const featuresTemp = getRolesFeatures(previewRole.roles);

    const roleTemp = {};

    roleTemp.roleItems = previewRole.roles[0].roleItems;
    roleTemp.features = featuresTemp;
    roleTemp.org = previewRole;

    const isAdmin = previewRole.config ? previewRole.config.isAdmin : false;

    const {
      isAuthenticated,
      id,
      username,
      email,
      cognitoUserId,
      avatar,
      notifications,
      msaStatus,
      ssoToken,
      campaignTableDisplayColumns,
    } = currentUser;

    const currentUserPermissions = currentUser.permission;

    const userData = {
      isAuthenticated,
      id,
      username,
      email,
      cognitoUserId,
      avatar,
      features: featuresTemp,
      notifications,
      defaultRole: {
        ...currentUser, // Why assign the whole currentUser object in defaultRole?
        org: currentUser.role.org,
      },
      role: roleTemp,
      isAdmin,
      isPreviewOrg: true,
      permission: {
        ...previewRole.config,
        isSelfService: currentUserPermissions.isSelfService,
        isTrafficker: currentUserPermissions.isTrafficker,
        isProcessor: currentUserPermissions.isProcessor,
        configurator: currentUserPermissions.configurator,
      },
      msaStatus,
      ssoToken,
      campaignTableDisplayColumns:
        campaignTableDisplayColumns && campaignTableDisplayColumns.length
          ? campaignTableDisplayColumns
          : [],
    };

    localStorage.setItem('userData', JSON.stringify(userData));
    await props.updateUser({
      variables: { ...userData },
    });
    props.history.push('/');
  };

  const updateOrgSendEmailConfig = async (data, id) => {
    const { campaignOrders: campaignOrdersValue, email, frequency, dayOfWeek } = data;

    let campaignOrders = campaignOrdersValue;
    try {
      if (Array.isArray(campaignOrdersValue)) {
        campaignOrders = campaignOrdersValue.map((obj) => obj.key).join(',');
      }

      const response = await props.updateOrgSendEmailConfig({
        variables: {
          id,
          campaignOrders,
          email,
          frequency,
          dayOfWeek,
        },
      });

      if (response) {
        return response;
      }
    } catch (err) {
      console.log(err);
      return false;
    }
  };

  const createDspAdvertiser = async (variables) => {
    try {
      const response = await props.createDspAdvertiserMutation({
        variables: {
          input: variables.variables.input,
        },
      });

      if (response) {
        return {
          status: 'success',
          error: null,
          data: response.data.createDspAdvertiser,
        };
      }
    } catch (err) {
      return {
        status: 'failure',
        error: err,
      };
    }
  };

  const createSalesforceForOrg = async (orgId, salesforceId) => {
    try {
      const response = await props.createSalesforceForOrgMutation({
        variables: { where: { id: orgId } },
      });

      if (response) {
        return {
          status: 'success',
          error: null,
          data: response.data.createSalesforceForOrg,
        };
      }
    } catch (err) {
      return {
        status: 'failure',
        error: err,
      };
    }
  };

  // Get lightweight org tree for sidebar
  const {
    loading: loadingOrgs,
    error: errorOrgs,
    data: dataOrgs,
    refetch: refetchOrganizations,
  } = useQuery(LIST_ORGS_TREE, {
    variables: {
      parentid: loggedInRole.org.id,
      first: pageSize,
      skip: (Number(pageNumber) - 1) * pageSize,
    },
    fetchPolicy: 'network-only',
  });

  if (loadingOrgs) return <OverlaySpinner />;

  // Prevent duplicate organizations by checking IDs before adding
  if (dataOrgs && dataOrgs.orgs.length > 0) {
    const existingIds = new Set(newOrgs.map((org) => org.id));
    const newOrgsToAdd = dataOrgs.orgs.filter((org) => !existingIds.has(org.id));

    if (newOrgsToAdd.length > 0) {
      setNewOrgs((prevOrgs) => [...prevOrgs, ...newOrgsToAdd]);
      setPageNumber(pageNumber + 1);
    }
  }

  if (errorOrgs) return `Error (Query: LIST_ORGS_TREE)! ${errorOrgs.message}`;

  return (
    <Controller
      organizations={newOrgs}
      createOrg={createOrg}
      editOrg={editOrg}
      disableOrg={disableOrg}
      deleteOrg={deleteOrg}
      fullDeleteOrg={fullDeleteOrg}
      enableOrg={enableOrg}
      refetchOrganizations={refetchOrganizations}
      currentuser={props.currentUser}
      currentOrgConfig={config}
      assumeRole={assumeRole}
      updateOrgSendEmailConfig={updateOrgSendEmailConfig}
      loadingOrgs={loadingOrgs}
      moveOrg={moveOrg}
      createDspAdvertiser={createDspAdvertiser}
      createSalesforceForOrg={createSalesforceForOrg}
    />
  );
};

export default compose(
  graphql(UPDATE_USER, { name: 'updateUser' }),
  graphql(CURRENT_USER, {
    props: ({ data: { currentUser }, ownProps }) => {
      return ownProps.currentUser || { currentUser };
    },
  }),
  graphql(CREATE_ORG_ADMIN, { name: 'createOrgMutation' }),
  graphql(EDIT_ORG_ADMIN, { name: 'updateOrgMutation' }),
  graphql(EDIT_ORG_SELF, { name: 'updateOrgBasic' }),
  graphql(DISABLE_ORG, { name: 'disableOrg' }),
  graphql(ENABLE_ORG, { name: 'enableOrg' }),
  graphql(DELETE_ORG_ADMIN, { name: 'deleteOrgMutation' }),
  graphql(FULL_DELETE_ORG_ADMIN, { name: 'fullDeleteOrgMutation' }),
  graphql(UPDATE_ORG_SEND_EMAIL_CONFIG, { name: 'updateOrgSendEmailConfig' }),
  graphql(MOVE_ORG, { name: 'moveOrgMutation' }),
  graphql(CREATE_DSP_ADVERTISER, { name: 'createDspAdvertiserMutation' }),
  graphql(CREATE_SALESFORCE_FOR_ORG, { name: 'createSalesforceForOrgMutation' })
)(Loader);
